export default "__VITE_ASSET__IkIlSsbM__"